const ROUTES = {
  LOGIN: "/login",
  HOME: "/",
  CUSTOMERS: "/customers",
  DRIVERS: "/drivers",
  REQUESTS: "/requests",
  BALANCES: "/balances",
  ACCOUNTS: "/accounts",
  UNAUTHORIZED: "/unauthorized",
  DRIVER_PROFILE: "/driver-profile/:driverId",
  USER_PROFILE: "/user-profile/:userId",
  PROFILE: "/profile",
  REDIRECT: "/redirect",
  BAG_MANAGER: "/bag-managers",
};

export default ROUTES;
